import { CreditCardRewardsType } from '../CreditCardRewardsTypes';

export const formatEarnRate = (
  earnRate: number,
  rewardsType: CreditCardRewardsType
) => {
  const suffix = rewardsType === CreditCardRewardsType.CASH_BACK ? '%' : 'x';
  return `${earnRate}${suffix}`;
};
